import { gql } from '@apollo/client';

export const priceFragment = gql`
  fragment priceFragment on Price {
    minPrice
    originalPrice
    itemType
    license
    licenseId
    personalized
  }
`;

export default gql`
  ${priceFragment}

  query GetProductsForFinder(
    $condition: Condition
    $sortBy: SortBy
    $search: String
    $language: Language
    $page: Int
    $hitsPerPage: Int
  ) {
    getProducts(
      language: $language
      condition: $condition
      sortBy: $sortBy
      search: $search
      page: $page
      hitsPerPage: $hitsPerPage
    ) {
      result {
        pageInfo {
          currentPage
          hasNextPage
        }
        items {
          id
          title
          sku
          image
          audioId
          videoId
          price {
            main {
              ...priceFragment
            }
            min {
              ...priceFragment
            }
            bundle {
              originalPrice
              diffPrice
              minPrice
            }
          }
          attributes(
            keys: [
              "sticker"
              "description"
              "detail_page"
              "pricing_page"
              "image_lazy"
              "override_price"
              "custom_price_text"
              "free"
            ]
          ) {
            key
            value
          }
        }
      }
    }
  }
`;
